/* Сопоставление текста отказа с ключом-образцом.

   Вынесено отдельно и без единого импорта: так его можно прогнать
   в node — без браузера, локали и Vue, — а проверка tools/i18n/сверить.mjs
   примеряет к образцам все тексты, которые действительно бросает сервер.

   Сервер подставляет значения ДО отправки: ключ «Станок {n1} не найден»
   приходит как «Станок ТЦ-01 не найден». Поэтому ключи с {n1} становятся
   регулярными выражениями. */

const кэш = new WeakMap();

export function образцы(словарь) {
  if (кэш.has(словарь)) return кэш.get(словарь);
  const список = [];
  for (const [ключ, перевод] of Object.entries(словарь)) {
    if (!ключ.includes('{n')) continue;
    const части = ключ.split(/(\{n\d+\})/);
    const рег = части.map((ч) => (/^\{n\d+\}$/.test(ч)
      ? '([\\s\\S]+?)'
      : ч.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'))).join('');
    /* Длина буквенной части — мера того, насколько образец конкретен. */
    список.push({ рег: new RegExp('^' + рег + '$'), перевод, вес: ключ.replace(/\{n\d+\}/g, '').length });
  }
  /* Конкретные образцы примеряем первыми: «Партия {n1} уже кончилась: {n2}»
     должен выиграть у «Партия уже кончилась: {n1}» — иначе более общий
     образец перехватил бы текст и потерял часть подстановок. */
  список.sort((a, b) => b.вес - a.вес);
  кэш.set(словарь, список);
  return список;
}

export function сопоставить(текст, словарь) {
  if (!текст || !словарь) return null;
  const точно = словарь[текст];
  if (точно) return точно;
  for (const { рег, перевод } of образцы(словарь)) {
    const m = текст.match(рег);
    if (!m) continue;
    return перевод.replace(/\{n(\d+)\}/g, (_, i) => m[Number(i)] ?? '');
  }
  return null;
}
